import React from "react";
import { cn } from "../utils";

const sizeMap = {
  sm: { box: "w-7 h-7 rounded-lg",  icon: "w-3.5 h-3.5" },
  md: { box: "w-9 h-9",            icon: "w-4.5 h-4.5" },
  lg: { box: "w-10 h-10 rounded-xl", icon: "w-5 h-5" },
};

export function IconBox({ icon: Icon, bg = "bg-blue-50", color = "text-blue-600", size = "md", className }) {
  const s = sizeMap[size];
  return (
    <div className={cn(s.box, bg, "flex items-center justify-center flex-shrink-0", className)}>
      <Icon className={cn(s.icon, color)} />
    </div>
  );
}
